import React from 'react';
import { Anchor, Typography, Grid, Section, Container } from 'components/base';

import { Head, Layout } from '../components/layout';
import SUPPORT_MENU_ITEMS from '../specifications/support';

const SupportPage = () => {
  return (
    <>
      <Head title="Support" />

      <Layout>
        <Section>
          <Container className="mw-800">
            <Typography.H1>SUPPORT</Typography.H1>
            <Typography.P>
              MyCanvas support is here to help. Learn more about popular topics and find resources
              that will help you with all of your issues.
            </Typography.P>

            <Grid.Row className="my-5">
              {SUPPORT_MENU_ITEMS.map(item => (
                <Grid.Col key={item.id} xs={6}>
                  <Anchor
                    href={item.url}
                    targetBlank={item.targetBlank}
                    key={item.id}
                    className="header-product w-100"
                  >
                    <img src={item.image} alt={item.label} className="header-support-img" />
                    <div className="mt-1">
                      <Typography.H4>
                        <Typography.Span>{item.label.toUpperCase()}</Typography.Span>
                      </Typography.H4>
                      <Typography.P className="small">{item.description}</Typography.P>
                    </div>
                  </Anchor>
                </Grid.Col>
              ))}
            </Grid.Row>
          </Container>
        </Section>
      </Layout>
    </>
  );
};

export default SupportPage;
